import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import QueryProvider from './providers/QueryProvider';
import LandingPage from './pages/LandingPage';
import BuilderPage from './pages/BuilderPage';
import WidgetRuntimePage from './pages/WidgetRuntimePage';

/**
 * Root app: maps URLs to page components.
 * /w/:widgetId → embeddable widget (iframe target)
 */
function App() {
  return (
    <QueryProvider>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/pricing" element={<Navigate to="/builder" replace />} />
        <Route path="/builder" element={<BuilderPage />} />
        <Route path="/w/:widgetId" element={<WidgetRuntimePage />} />
      </Routes>
    </BrowserRouter>
    </QueryProvider>
  );
}

export default App;
